(() => {
  const MEASUREMENT_ID = 'G-BNWZEVD85R';
  const PRODUCT_SELECTOR = 'main-product-default';
  const VARIANT_SELECTOR = '[js-variant-input]';
  const AMP_TRIGGER_SELECTOR = '#BIS_trigger, [data-biv-amp-fallback]';
  const AMP_FRAME_SELECTOR = '#BIS_frame';
  const DEBUG_MODE = new URLSearchParams(window.location.search).has('biv_tracking_debug');
  let googleTagInitialized = false;

  const ensureGoogleTag = () => {
    if (googleTagInitialized) return;
    googleTagInitialized = true;

    const hadGtag = typeof window.gtag === 'function';
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    if (!hadGtag) {
      window.gtag('js', new Date());
    }

    window.gtag('config', MEASUREMENT_ID, {
      send_page_view: false,
      debug_mode: DEBUG_MODE,
    });

    const existingGtagScript = Array.from(document.scripts).find((script) =>
      script.src.includes('googletagmanager.com/gtag/js')
    );

    if (!existingGtagScript && !document.querySelector('script[data-biv-amp-ga4]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
      script.dataset.bivAmpGa4 = 'true';
      if (DEBUG_MODE) {
        script.addEventListener('load', () => {
          document.documentElement.dataset.bivTrackingLoader = 'loaded';
        });
        script.addEventListener('error', () => {
          document.documentElement.dataset.bivTrackingLoader = 'error';
        });
      }
      document.head.appendChild(script);
    } else if (DEBUG_MODE) {
      document.documentElement.dataset.bivTrackingLoader = 'loaded';
    }
  };

  const analyticsAllowed = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;

    return !privacy
      || typeof privacy.analyticsProcessingAllowed !== 'function'
      || privacy.analyticsProcessingAllowed();
  };

  const sendEvent = (name, parameters) => {
    if (!analyticsAllowed()) return;

    ensureGoogleTag();
    const eventParameters = {
      send_to: MEASUREMENT_ID,
      ...parameters,
    };

    if (DEBUG_MODE) {
      const history = JSON.parse(
        document.documentElement.dataset.bivTrackingHistory || '[]',
      );
      history.push({ name, parameters });
      document.documentElement.dataset.bivTrackingHistory = JSON.stringify(
        history.slice(-20),
      );
      document.documentElement.dataset.bivTrackingQueued = JSON.stringify({
        name,
        parameters,
      });
      eventParameters.event_timeout = 2000;
      eventParameters.event_callback = () => {
        document.documentElement.dataset.bivTrackingSent = name;
      };
      eventParameters.debug_mode = true;
    }

    window.gtag('event', name, eventParameters);
  };

  const variantName = (root, control) => {
    if (control && control.matches('select')) {
      return control.selectedOptions[0]?.textContent?.trim() || '';
    }

    return control
      ?.closest('.variant-option__label')
      ?.querySelector('[js-chip], [js-swatch]')
      ?.textContent
      ?.trim()
      || root.querySelector('[js-variant-label-value]')?.textContent?.trim()
      || '';
  };

  const selectedControl = (root) => root.querySelector(
    'input[js-variant-input][type="radio"]:checked, select[js-variant-input]',
  );

  const eventParameters = (root, control = selectedControl(root)) => {
    const selectedOption = control?.matches('select')
      ? control.selectedOptions[0]
      : null;
    const variantId = control?.dataset.variantId
      || selectedOption?.dataset.variantId
      || control?.value
      || root.querySelector('[data-current-product-id]')?.dataset.currentProductId
      || '';
    const isAvailable = control?.matches('select')
      ? !selectedOption?.disabled
      : !control?.classList.contains('disabled');

    return {
      product_id: root.dataset.productId || '',
      product_name: document.querySelector('meta[property="og:title"]')?.content
        || document.title.replace(/\s+-\s+[^-]+$/, ''),
      variant_id: String(variantId),
      variant_name: variantName(root, control),
      variant_available: Boolean(isAvailable),
      event_source: 'product_page',
    };
  };

  const trackFormOpen = (root, parameters) => {
    const startedAt = performance.now();

    const checkFrame = () => {
      const frame = document.querySelector(AMP_FRAME_SELECTOR);
      const isOpen = frame
        && getComputedStyle(frame).display !== 'none'
        && frame.getClientRects().length > 0;

      if (isOpen) {
        sendEvent('biv_back_in_stock_form_open', parameters);
        return;
      }

      if (performance.now() - startedAt < 3000 && root.isConnected) {
        requestAnimationFrame(checkFrame);
      }
    };

    requestAnimationFrame(checkFrame);
  };

  document.addEventListener('change', (event) => {
    const control = event.target?.closest?.(VARIANT_SELECTOR);
    const root = control?.closest(PRODUCT_SELECTOR);

    if (!root) return;

    const parameters = eventParameters(root, control);
    sendEvent('biv_variant_selected', parameters);

    if (!parameters.variant_available) {
      sendEvent('biv_unavailable_variant_selected', parameters);
    }
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target?.closest?.(AMP_TRIGGER_SELECTOR);
    const root = trigger?.closest(PRODUCT_SELECTOR);

    if (!root) return;

    const parameters = eventParameters(root);
    sendEvent('biv_back_in_stock_click', parameters);
    trackFormOpen(root, parameters);
  }, true);

  document.addEventListener('visitorConsentCollected', (event) => {
    if (event.detail?.analyticsAllowed) ensureGoogleTag();
  });
})();
